module.exports = __webpack_public_path__ + "img/video.a39e2ec4.jpg";